/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SubmitPasswordResetInput = {
    token: string;
    clientMutationId?: string | null | undefined;
};
export type ResetPasswordControllerMutationVariables = {
    input: SubmitPasswordResetInput;
};
export type ResetPasswordControllerMutationResponse = {
    readonly submitPasswordReset: {
        readonly passwordSubmissionData: {
            readonly token: string;
            readonly publicKey: string;
        } | null;
        readonly clientMutationId: string | null;
    } | null;
};
export type ResetPasswordControllerMutation = {
    readonly response: ResetPasswordControllerMutationResponse;
    readonly variables: ResetPasswordControllerMutationVariables;
};



/*
mutation ResetPasswordControllerMutation(
  $input: SubmitPasswordResetInput!
) {
  submitPasswordReset(input: $input) {
    passwordSubmissionData {
      token
      publicKey
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitPasswordResetPayload",
    "kind": "LinkedField",
    "name": "submitPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PasswordSubmissionData",
        "kind": "LinkedField",
        "name": "passwordSubmissionData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetPasswordControllerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetPasswordControllerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc8135fc522cea54444cdc5eedf669a9",
    "id": null,
    "metadata": {},
    "name": "ResetPasswordControllerMutation",
    "operationKind": "mutation",
    "text": "mutation ResetPasswordControllerMutation(\n  $input: SubmitPasswordResetInput!\n) {\n  submitPasswordReset(input: $input) {\n    passwordSubmissionData {\n      token\n      publicKey\n    }\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '92ad5eabf08b0fb86cf0eb5a444913be';
export default node;
